import { useState } from 'react';
import { ItineraryWarning } from 'core/graphql/types';

export interface ItineraryWarningsGroupProps {
  warningGroup: string;
  warnings: Array<ItineraryWarning>;
}

const ItineraryWarningsGroup = ({
  warningGroup,
  warnings,
}: ItineraryWarningsGroupProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const warningMapping: { [id: string]: string } = {
    ETA_ABOVE_TIME_LIMIT: 'ETA is greater than time limit',
    DISTANCE_BETWEEN_TWO_STOPS_GREATER_THAN_LIMIT:
      'Distance between stops is greater than time limit',
    UNREACHABLE_ADDRESS: 'Address is unreachable',
    TIME_WINDOW_CONSTRAINT: 'Pick-up/PUDO cannot be reached in time window',
  };
  return (
    <div>
      <div
        onClick={() => setIsOpen(!isOpen)}
        className={`mt-2 w-full break-words rounded-sm bg-muted-white p-1  pl-2 hover:cursor-pointer  hover:bg-design-black hover:text-white hover:outline hover:outline-1 hover:outline-design-red dark:bg-design-secondary-black ${
          isOpen ? 'bg-red text-white' : ''
        }`}
        aria-hidden
      >
        {warningMapping[`${warningGroup}`]}
      </div>
      {isOpen && (
        <div>
          {warnings.map((warning) => (
            <div
              key={warning.id}
              className="mt-2 w-full break-words rounded-sm bg-muted-white p-1 text-center  dark:bg-design-secondary-black"
            >
              {warning.errorMessage}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ItineraryWarningsGroup;
